import { uiVisibilityApi } from "../../api";

const UiVisibilityService = {
  /**
   * 🔹 Obtener todas las configuraciones de visibilidad registradas
   */
  getAll: async () => {
    const response = await uiVisibilityApi.fetchAll();
    return response.data;
  },

  /**
   * 🔹 Actualizar el estado visible/oculto de un elemento UI
   * - Envía el DTO completo al backend
   * - Usa modifyCustom() con la ruta /update-visibility
   * - El backend devuelve un `boolean` con el nuevo estado
   */
  updateVisibility: async (payload: { code: string; visible: boolean }) => {
    const response = await uiVisibilityApi.modifyCustom("/update-visibility", payload);
    return response.data; 
  },
};

export default UiVisibilityService;
